export const mutations = {
    UPDATE_SIDEBAR_WIDTH(state, width) {
        state.sidebarWidth = width;
    },
    UPDATE_SIDEBAR_ITEMS_MIN(state, val) {
        state.sidebarItemsMin = val;
    },
    TOGGLE_REDUCE_BUTTON(state, val) {
        state.reduceButton = val;
    },
    TOGGLE_CONTENT_OVERLAY(state, val) {
        state.bodyOverlay = val;
    },
    TOGGLE_IS_SIDEBAR_ACTIVE(state, value) {
        state.isSidebarActive = value;
    },
    UPDATE_WINDOW_BREAKPOINT(state, val) {
        state.breakpoint = val;
    },
    UPDATE_STARRED_PAGE(state, payload) {
        const index = state.navbarSearchAndPinList.data.findIndex((item) => item.index == payload.index);
        state.navbarSearchAndPinList.data[index].highlightAction = payload.val;
    },
    UPDATE_TOKEN(state, token) {
        state.authToken = token;
    },
    UPDATE_USER(state, user) {
        state.currentUser = user;
    },
    UPDATE_DATE_RANGE(state, payload) {
        state.daterange.startDate = payload.startDate;
        state.daterange.endDate = payload.endDate;
    },
    UPDATE_USERS(state, usuarios) {
        state.usuarios = usuarios;
    },
    ADD_TOKEN(state, { token, source }) {
        Object.assign(state.axios_req, {[token]: source});
    },
    REM_TOKEN(state, key) {
        delete state.axios_req[key];
    },
    UPDATE_THEME(state, val) {
        state.theme = val;
    },
    UPDATE_ROLE(state, role) {
        state.currentUser.usuario_cargo = role;
    },
};
